import styles from './certificate-status-pop.module.scss';
import {Field, Form, Formik, FormikErrors, FormikValues} from 'formik';
import {useRef} from "react";
import classNames from 'classnames/bind';
import { useInjection } from 'inversify-react';
import { SelectItem } from '../model/types';
import { DialogManager } from './dialog-manager';
import { CustomerShareApi } from '../model/customer/customer-share-api';

const cx = classNames.bind(styles);

interface CompanyInfoUpdatePopProps {
    customerId: string
    onClose: VoidFunction
}

const updateInfos: SelectItem[] = [
    {id: 'FR_STAT', title: '상세재무정보'},
    {id: 'CORP_REG', title: '법인등기부등본 정보'},
    {id: 'EMP_CNT', title: '상시근로자수'},
    {id: 'CERT', title: '기업인증현황'},
    {id: 'IPR', title: '산업재산권'},
];

const CompanyInfoUpdatePop = ({customerId, onClose}: CompanyInfoUpdatePopProps) => {
    const dialogManager = useInjection(DialogManager);
    const customerApi = useInjection(CustomerShareApi);

    const initValues: {[key: string]: boolean} = {
        'FR_STAT': false,
        'CORP_REG': false,
        'EMP_CNT': false,
        'CERT': false,
        'IPR': false,
    }

    return (
        <div className='full-background'>
            <Formik
                initialValues={initValues}
                onSubmit={async (values) => {
                    console.log(values);
                    const requestInfos = [];

                    for(let key in values) {
                        if (values[key]) {
                            requestInfos.push(key);
                        }
                    }

                    if (requestInfos.length === 0) {
                        dialogManager.alert("업데이트할 기업정보를 선택해 주세요.");
                        return;
                    }

                    const result = await customerApi.updateRecentDetailCompanyInfo(customerId, requestInfos);
                    console.log(result);

                    if (result && result.success) {
                        dialogManager.alert("기업정보 업데이트가 요청되었습니다.", "기업정보 업데이트에 1~3분 정도의 시간이 소요될 수 있습니다.", () => {onClose();});
                    } else {
                        dialogManager.alert("기업정보 업데이트 요청에 실패했습니다.");
                        return;
                    }

                    // onClose();
                }}>
                <Form>
                    <div className={`pop-inner ${cx('certificate-status-pop')}`}>
                        <p className={cx('title')}>업데이트할 기업정보를 선택해 주세요. (중복 선택 가능)</p>
                        <div className={cx('certificate-list')}>
                            {updateInfos.map((it) =>
                                <label key={it.id} className={cx('check-box')}>
                                    <Field type='checkbox' name={it.id} />{it.title}
                                </label>
                            )}
                        </div>
                        <div className={cx('btn-area')}>
                            <button type='button' className={cx('close-btn')} onClick={onClose}>닫기</button>
                            <button type='submit' className={cx('save-btn')}><i></i>업데이트</button>
                        </div>
                    </div>
                </Form>
            </Formik>
        </div>
    );
};

export default CompanyInfoUpdatePop;